import * as installDevice from 'actions/installDevice';
import * as devicesActions from 'actions/devices';

export const defaultState = {
  isFetchingInitial: false,
  isDeviceRegistered: false,
  emailInviteSending: false,
  emailInviteSent: false,
  showEmailInviteInput: false,
  isMobileOpen: false,
  isChatOpen: false,
};

export function hasNewDevice(devices, initialDevices = []) {
  let isDevicesRegistered = false;

  // for each device in current list
  devices.some(newItem => {
    let isInInitialList = false;
    let isStateChangedToEnabled = false;
    let isRegistrationIdChanged = false;
    let isApnTokenChanged = false;

    // compare to the initial list
    initialDevices.some(initialItem => {
      // if a match was found see if identity or status was changed
      if (newItem.id === initialItem.id) {
        isInInitialList = true;
        isStateChangedToEnabled =
          newItem.status === 'ACTIVE' && initialItem.status === 'INACTIVE';
        isRegistrationIdChanged =
          newItem.registrationId &&
          initialItem.registrationId &&
          newItem.registrationId !== initialItem.registrationId;
        isApnTokenChanged =
          newItem.apnToken &&
          initialItem.apnToken &&
          newItem.apnToken !== initialItem.apnToken;
      } // if not found yet, have to search exhaustively to see if it is actually new
      return (
        isStateChangedToEnabled || isApnTokenChanged || isRegistrationIdChanged
      );
    });

    isDevicesRegistered =
      !isInInitialList ||
      isStateChangedToEnabled ||
      isRegistrationIdChanged ||
      isApnTokenChanged;
    return isDevicesRegistered; // break out of iteration if conditions are met even for one device
  });

  return isDevicesRegistered;
}

export function mobileDeviceFilter(device) {
  return (
    device.deviceType === 'APPLE_PUSH' || device.deviceType === 'ANDROID_PUSH'
  );
}

export default function installDeviceReducer(state = defaultState, action) {
  switch (action.type) {
    case installDevice.SET_INSTALL_CHAT_APP_DIALOG_OPEN: {
      return {
        ...state,
        isChatOpen: !!action.payload,
      };
    }
    case installDevice.SET_INSTALL_MOBILE_APP_DIALOG_OPEN: {
      let nextState = {
        ...state,
      };
      if (!action.payload) {
        nextState = defaultState;
      } else {
        nextState.isMobileOpen = action.payload;
        nextState.isFetchingInitial = action.payload;
      }
      return nextState;
    }
    case devicesActions.LOAD_USER_DEVICES_SUCCESS: {
      const devices = action.payload.data.filter(mobileDeviceFilter);
      const nextState = {
        ...state,
      };
      if (nextState.isFetchingInitial) {
        nextState.initialDevices = devices;
        nextState.isFetchingInitial = false;
      } else if (hasNewDevice(devices, nextState.initialDevices)) {
        nextState.isDeviceRegistered = true;
      }
      return nextState;
    }
    case installDevice.EMAIL_INVITE_SENDING: {
      return {
        ...state,
        emailInviteSent: false,
        emailInviteSending: true,
      };
    }
    case installDevice.EMAIL_INVITE_SENT: {
      return {
        ...state,
        emailInviteSent: true,
        emailInviteSending: false,
        showEmailInviteInput: false,
      };
    }
    case installDevice.SHOW_STEP1_INVITE_INPUT: {
      return {
        ...state,
        emailInviteSent: false,
        emailInviteSending: false,
        showEmailInviteInput: true,
      };
    }
    default: {
      return state;
    }
  }
}
